import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import {
    WorkoutContainerHeaderTwo,
    WorkoutContainerHeaderThree,
    WorkoutContainerText,
    WorkoutTextHeader,
    WorkoutCommonButton,
    WorkoutButtonTwo
} from '../styles/common-styles.js';
import styled from 'styled-components/native';
import { resetPassword } from '../reducers/cbcAccountActionsSlice.js';
import { LinearGradient } from 'expo-linear-gradient';

function ForgotPassword({ route, callbackFunction = null }) {
    let { invokedFromSettings = 0 } = route.params || {};

    const [passwordResetMsg, setPasswordResetMsg] = useState('Enter your email below. A reset password link will be sent to your email.');
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');

    const { loading_msg, results_msg } = useSelector((state) => state.accountActions);

    function sendForgottenPasswordEmail(email) {
        dispatch(resetPassword(email));
    }

    useEffect(() => {
        if (results_msg !== '') {
            setPasswordResetMsg(results_msg);
        }
    }, [results_msg]);

    return (
        <ForgotPasswordParent invokedFromSettings={invokedFromSettings}>
            {invokedFromSettings == 1 && (
                <>
                    <LinearGradient
                        style={{
                            position:'absolute',
                            top:0,
                            left:0,
                            right:0,
                            bottom:0,
                            width:'100%',
                            height:'100%'
                        }}
                        colors={['rgb(65, 103, 176) ', 'rgb(192, 77, 151)']}
                    />

                    <Logo
                        source={{
                            uri: 'https://cerebrocoreusa.com/wp-content/uploads/2022/04/CerebroCore_Primarylogos_BrainOp_White_640.png',
                        }}
                        resizeMode='contain'
                    />
                </>
            )}

            <WorkoutTextHeader style={{marginTop:25, color:'white'}}>Reset Password</WorkoutTextHeader>
            <WorkoutContainerText style={{marginTop:10, textAlign:'center', color:'white'}}>{passwordResetMsg}</WorkoutContainerText>
            <EmailInput
                autoCorrect={false}
                autoCapitalize='none'
                onChangeText={(text) => setEmail(text)}
                value={email}
                style={{marginTop:20}}
                placeholder='Email'
            />
            <WorkoutCommonButton
                style={{marginTop:20}}
                onPress={() => sendForgottenPasswordEmail(email)}
                disabled={loading_msg === 'pending'}
            >
                <WorkoutContainerText style={{color:'white', textAlign:'center'}}>
                    {loading_msg === 'pending' ? 'SENDING...' : 'RESET PASSWORD'}
                </WorkoutContainerText>
            </WorkoutCommonButton>
            {invokedFromSettings == 0 && (
                <WorkoutCommonButton style={{marginTop:15}}>
                    <WorkoutContainerText style={{color:'white', textAlign:'center'}} onPress={() => callbackFunction()}>BACK</WorkoutContainerText>
                </WorkoutCommonButton>
            )}
        </ForgotPasswordParent>
    );
}

export const ForgotPasswordParent = styled.View`
  height:${(props) => (props.invokedFromSettings == 0 ? 'auto' : '100%')};
  width:100%;
  max-width:${(props) => (props.invokedFromSettings == 0 ? '300px' : '100%')};
  display:flex;
  justify-content:center;
  text-align:center;
  align-items:center;
`;

export const EmailInput = styled.TextInput`
  border: 0.5px solid lightgray;
  background:#fff;
  border-radius: 5px;
  width: 275px;
  height: 40px;
  margin-top: 10px;
  padding:10px;
  font-size:22px;
`;

export const Logo = styled.Image`
  width:100%;
  height: 125px;
  margin-bottom: 25px;
  padding-right:25px;
  padding-left:25px;
`;

export default ForgotPassword;